import React from 'react';
import {
    NavLink,
    Route,
    Switch,
    useRouteMatch,
    Redirect,
} from 'react-router-dom';

import Nav from '../../Nav';
import Accounts from './Accounts';
import { NavLead } from '../Dashboard.stc';

function Admin(props) {
    const { url, path } = useRouteMatch();

    return (
        <>
            <Nav activeBorder>
                <div className="container">
                    <NavLead>Admin</NavLead>
                    <ul className="nav unstyle">
                        <li>
                            <NavLink exact to={url + '/websites'}>
                                Websites
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={url + '/accounts'}>Accounts</NavLink>
                        </li>
                    </ul>
                </div>
            </Nav>
            <div className="container" style={{ marginTop: 30 }}>
                {/* <Route exact path={path} component={Websites} /> */}
                <Switch>
                    <Route exact path={url}>
                        <Redirect to={url + '/accounts'} />
                    </Route>
                    <Route path={url + '/accounts'} component={Accounts} />
                </Switch>
            </div>
        </>
    );
}

export default Admin;
